import React, { useEffect } from 'react';
import { Controls } from 'shared/helper/form';
import { T } from 'shared/helper/translate';
import { price } from 'researcher/helpers/price';
import PartialPrepayment from './PartialPrepayment';
var Radio = Controls.Radio;
var Prepayment = function Prepayment(_ref) {
  var currency = _ref.currency,
    maximumApplicableUsdPrepaymentBalance = _ref.maximumApplicableUsdPrepaymentBalance,
    resetPrepayment = _ref.resetPrepayment,
    maxPrepayCoversCost = _ref.maxPrepayCoversCost,
    prepaymentOption = _ref.prepaymentOption,
    updatePrepaymentApplied = _ref.updatePrepaymentApplied,
    usdPrepaymentBalance = _ref.usdPrepaymentBalance;
  useEffect(function () {
    return resetPrepayment;
  }, []);
  var adjustPrepaymentBalanceApplied = function adjustPrepaymentBalanceApplied(prepaymentType) {
    var prepaymentToApply = prepaymentType === 'fullPayment' ? maximumApplicableUsdPrepaymentBalance : 0;
    updatePrepaymentApplied(prepaymentToApply);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "You have **%(amount)s** available in your prepay account.",
    params: {
      amount: price(currency, usdPrepaymentBalance, true, true)
    }
  }), /*#__PURE__*/React.createElement(Radio, {
    name: "prepaymentOption",
    styles: {
      wrapper: 'mb-3'
    },
    onChange: adjustPrepaymentBalanceApplied,
    options: [{
      value: 'fullPayment',
      label: /*#__PURE__*/React.createElement(T.md, {
        inline: true,
        source: maxPrepayCoversCost ? 'Pay for this order with **%(amount)s** from prepay' : 'Apply **%(amount)s** from prepay to this order',
        params: {
          amount: price(currency, maximumApplicableUsdPrepaymentBalance, true, true)
        }
      })
    }, {
      value: 'partialPayment',
      label: /*#__PURE__*/React.createElement(PartialPrepayment, {
        currency: currency,
        maximumApplicableUsdPrepaymentBalance: maximumApplicableUsdPrepaymentBalance,
        prepaymentOption: prepaymentOption,
        updatePrepaymentApplied: updatePrepaymentApplied
      })
    }, {
      value: 'none',
      label: /*#__PURE__*/React.createElement(T.md, {
        source: "Use another payment method",
        inline: true
      })
    }]
  }));
};
export default Prepayment;